import { GetFontAwesomeIcon } from "@/components/font-awesome-icon";
import { Avatar, Box, Typography, useTheme } from "@mui/material";

const IconWithDetails = ({
  icon,
  heading,
  subHeading = "",
  description,
  iconsx = {},
  color,
  subHeadingSX = {},
  subHeadingRest = {},
}) => {
  const { palette } = useTheme();

  return (
    <Box sx={{ display: "flex", alignItems: "center", py: 1 }}>
      <Avatar
        sx={{
          backgroundColor: "var(--palette-secondary_button)",
          // backgroundColor: color ?? palette.secondary.main,
          color: "var(--palette-secondary_button_text)",
          mr: 2,
          width: 38,
          height: 38,
        }}
      >
        <GetFontAwesomeIcon
          icon={icon}
          iconStyles={{ fontSize: "1.2rem", marginRight: "0px", ...iconsx }}
        />
      </Avatar>
      <Box>
        <Typography
          variant="body1"
          sx={{
            fontWeight: 400,
            lineHeight: 1.4,
            color: "var(--palette-grey_text)",
            fontSize: "0.8rem",
          }}
        >
          {heading}
        </Typography>
        <Typography
          variant="body2"
          component="div"
          sx={{ fontWeight: 400, lineHeight: 1.4, ...subHeadingSX }}
          {...subHeadingRest}
        >
          {subHeading ?? ""}
        </Typography>
        {description ? (
          <Typography variant="body2">{description}</Typography>
        ) : null}
      </Box>
    </Box>
  );
};

export default IconWithDetails;
